import { useRouter } from "next/router";
import { getAlternateLocaleByCode } from "@common/types/Locale";
import classNames from "classnames";
import { GlobeIcon } from "@talladega/icons";

type Props = {
  className?: string;
};

const LocaleButton = ({ className }: Props) => {
  const router = useRouter();
  const linkLocale = getAlternateLocaleByCode(router.locale || "en");

  const handleLocaleChange = () => {
    router.push(router.asPath, router.asPath, { locale: linkLocale.code });
  };

  return (
    <button
      type="button"
      onClick={handleLocaleChange}
      className={classNames("flex items-center space-x-2 transition", {
        "text-white hover:text-white/80": !className,
        [className || ""]: className,
      })}
    >
      <GlobeIcon className="h-6 w-6" />
      <span className="font-bold">{linkLocale.code.toUpperCase()}</span>
    </button>
  );
};

export default LocaleButton;
